import Vue from 'vue';
import Component from 'vue-class-component';
import { sendAnalyticsEvent } from 'common/utils/sendAnalyticsEvent';
import FacebookApiKeys from 'assets/graphql/queries/FacebookApiKeys.graphql';
import useAccount from 'composables/useAccount';

import outSideClick from 'directives/outSideClick';

Vue.directive('outSideClick', outSideClick);

@Component({
  directives: {
    clickOutside: outSideClick.directive,
  },
  apollo: {
    facebook_api_key: {
      query: FacebookApiKeys,
    },
  },
  props: {
    product: {
      type: Object,
      description: 'to be sent to analytics',
    },
    sendIconColor: {
      default: '--black',
    },
    tooltipTopPosition: {
      default: '35',
    },
  },
  setup() {
    const { getUserData } = useAccount();
    return {
      getUserData,
    };
  },
})
export default class SocialShareComponent extends Vue {
  showOptions = false;
  shareText = 'Mirá este regalo original';
  redirect = '';

  toggleShareOption() {
    this.showOptions = !this.showOptions;
  }

  onClickOutside() {
    this.showOptions = false;
  }

  onShareClick(method) {
    switch (method) {
      case 'meta':
        return `https://www.facebook.com/dialog/share?app_id=${this.facebook_api_key}
                 &display=page&href=${this.url}&redirect_uri=${this.url}`;
      case 'whatsapp':
        return `https://api.whatsapp.com/send?phone=&text=${this.shareText} ${this.url}`;
      default:
        return `mailto:?subject=${this.shareText}&body=${this.shareText}%0D%0A%0D%0A ${this.url}`;
    }
  }

  sendAnalytics(method) {
    sendAnalyticsEvent('share', undefined, {
      method,
      content_type: this.product.__typename,
      item_id: this.product.id,
      userData: {
        email: this.email,
      },
    });
  }

  get url() {
    return window.location.href;
  }

  get email() {
    return this.getUserData?.email || '';
  }
}
